// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';

export default class RolesActionsPermissionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'rolesActionsPermissions';
        this.Server =
            this.props.context.getState().server.rolesActionsPermissions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['actions'];
        this.showDatePicker = false;
        this.CheckboxCell = false;
        this.NeedSearch = false;
        this.disableGlobalEditor = true;
        this.disableAdd = true;
        this.disableGlobalDelete = true;

        const defaultHead = [
            {
                id: 'permissionName',
                label: 'permissionName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true,
                disableEditor: true,
                disableSort: true,
            },
            {
                id: 'roleId',
                label: 'role',
                alignRight: false,
                cell: 'Select',
                show: 'name',
                from: 'roles',
                object: 'role',
                // translate: 'enums',
                filterCell: 'Context',
                filterBy: 'roles',
                displayGrid: true,
                disableEditor: true,
                disableSort: true,
            },
            {
                id: 'allowed',
                label: 'allowed',
                alignRight: false,
                cell: 'EditorSelect',
                items: ['allow', 'deny'],
                displayGrid: true,
                disableEditor: true,
                disableSort: true,
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    async retrieveData() {
        await super.retrieveData();
        this.setState((prevState) => ({
            currentValues: this.List.reduce((acc, cur) => {
                acc[cur.id] = {
                    allowed: cur.allowed,
                    roleId: cur.roleId,
                    permissionName: cur.permissionName
                };
                return acc;
            }, {})
        }));
    }

    handleChangeCell = (event, permissionId, cellId) => {
        const { value } = event.target;
        this.setState((prevState) => ({
            currentValues: {
                ...prevState.currentValues,
                [permissionId]: {
                    ...prevState.currentValues[permissionId],
                    [cellId]: value
                }
            }
        }));
    };

    handleSaveCell = async (id, role, _) => {
        let { permissionName, ...data } = this.state.currentValues[id];
        const newData = { ...data, roleId: role.id, permissionName };

        if (Object.keys(data).length) {
            await this.Server.update(id, newData);
        }

        this.retrieveData().then(() => this.updatePermissionsData());
    };

    renderCheckboxCell = () => {
        return null;
    };
}
